import React from 'react';
import {
  Col,
  Row,
  FormGroup,
  Input,
  Label,
} from 'reactstrap';

const DummyTaxTemplate = () => (
  <div className="mb-2">
    <Row>
      <Col xs={4}>
        <Label className="fw-bold">Charge Type: Tax</Label>
      </Col>
    </Row>
    <Row>
      <Col xs={3}>
        <FormGroup>
          <Label className="fw-bold">Name</Label>
          US Sales Tax
        </FormGroup>
      </Col>
      <Col xs={2}>
        <FormGroup>
          <Label className="fw-bold">Rate %</Label>
          Auto-Calculated
        </FormGroup>
      </Col>
      <Col xs={3}>
        <FormGroup>
          <Label className="fw-bold">Country / Region</Label>
          United States of America
        </FormGroup>
      </Col>
    </Row>
    <Row>
      <Col xs={3}>
        <Label className="fw-bold">Apply tax type to:</Label>
      </Col>
      <Col xs={2}>
        <FormGroup check>
          <Input
            type="checkbox"
            id="taxHammer"
            name="taxHammer"
            checked={true}
            disabled={true}
          />
          <Label check>
            Hammer
          </Label>
        </FormGroup>
      </Col>
      <Col xs={2}>
        <FormGroup check>
          <Input
            type="checkbox"
            id="taxLiveFee"
            name="taxLiveFee"
            checked={true}
            disabled={true}
          />
          <Label check>
            Live Fee
          </Label>
        </FormGroup>
      </Col>
      <Col xs={2}>
        <FormGroup check>
          <Input
            type="checkbox"
            id="taxPremium"
            name="taxPremium"
            checked={true}
            disabled={true}
          />
          <Label check>
            BP
          </Label>
        </FormGroup>
      </Col>
    </Row>
  </div>
);

export default DummyTaxTemplate;
